var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoRund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-869.621 -375.721)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#c5d75d",
    transform: "translate(869.621 375.721)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M902.449 484.856a3.389 3.389 0 0 0-2.066 6.078l-5.274 13.574v-21.692l5.151-5.152a2.2 2.2 0 1 0-.435-.473l-4.716 4.716v-3.973a3.391 3.391 0 1 0-1.07-.009v23.842l-3.367-18.678a3.4 3.4 0 1 0-1.065.125l1.907 10.582-7.8-7.215a2.214 2.214 0 1 0-.412.494l8.4 7.771L894 507.581a.535.535 0 0 0 .475.437.433.433 0 0 0 .051 0 .535.535 0 0 0 .5-.341l6.306-16.231a3.392 3.392 0 1 0 1.118-6.594zm-15.026-5.028a2.323 2.323 0 1 1 2.323 2.323 2.326 2.326 0 0 1-2.323-2.323zm4.86-5.245a2.323 2.323 0 1 1 2.323 2.323 2.326 2.326 0 0 1-2.323-2.323zm10.167 15.989a2.323 2.323 0 1 1 2.323-2.323 2.326 2.326 0 0 1-2.324 2.323z",
    transform: "translate(-1.224 -90.384)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRund);
export default __webpack_public_path__ + "static/media/logo-rund.674d4a5f6c6acbbc97fd3dbb4f07c8cf.svg";
export { ForwardRef as ReactComponent };